var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.bannerImg),expression:"bannerImg"}],attrs:{"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }